import React, { useEffect, useState } from 'react';

import SimpleTable from 'ui/Table';
import { getSubscriptionSummary } from '../../services';

export function SubscriptionBox() {
    const [subscription, setSubscription] = useState([]);
    const TITLES = {
        name: 'Subscription level',
        owner: 'Account owner',
        seats: 'Total user licenses',
        maximum_devices: 'Device activation limit',
    };

    const cellFormat = (formater = val => val) => (value, row) => (
        <span style={{ fontWeight: '500' }}>{formater(value)}</span>
    );

    useEffect(() => {
        getSubscriptionSummary()
            .then((subscription = []) => {
                const { data } = subscription;
                if (data) setSubscription(getRows(data));
            })
            .catch(() => {
                setSubscription([]);
            });
    }, []);

    const getRows = data => {
        const rows = [];
        Object.entries(TITLES).forEach(([key, title]) => {
            const param = data[key];
            if (param == null) return;
            const value = param === 0 ? 'Unlimited' : param;
            rows.push([title, value]);
        });
        return rows;
    };

    const options = {
        compact: true,
        columns: [
            { styles: { width: '50%', align: 'left' }, format: cellFormat() },
            { styles: { align: 'center' } },
        ],
    };

    return <SimpleTable data={subscription} options={options} />;
}
